<template>
  <div class="bgShareLive">
    <div class="hindBox" ref="hindBox"></div>
    <lvVideo v-if="status!=0" class="lvVideo" :baseInfo="baseInfo" :status="status" :startSurplusTime="startSurplusTime" ref="lvVideo"></lvVideo>
    <lvInfo class="infoBox" :baseInfo="baseInfo" :isOrder="isOrder" :status="status" ></lvInfo>
  </div>
</template>

<script>

import {apiLive} from "../../network/app/apiPlatformLive";
import lvVideo from "./liveItem/lvVideo";
import lvInfo from "./liveItem/lvInfo";
import {utils} from "../../network/utils";
import {wxAuth} from "../../network/wx/wxAuth";
import {openLaunchInit} from "../../js/activity/share";
import {baseConfig} from "../../network/baseConfig";
import {browser} from "../../js/browser";
import {actUtil} from "../../js/activity/util";


export default {
  name: "shareLive",
  components:{
    lvVideo,
    lvInfo
  },
  data(){
    return {
      //是否使能直播
      isEnableLive: false,

      liveId: 0,
      isOrder: 0,        //是否预约    (boolean)
      baseInfo: {
        'id': 0,
        'orderNum': 0,
        'image': '',
        'http': '',
        'record': '',
        'note': '',

        'articles': [],
        'liveTime': [],
        'liveLecturer': [],

      },

      //定时器
      timer: '',
      //直播状态
      status: 0, //0未设定状态 1未开始 2正在直播 3直播结束

      //距直播开始时间
      startSurplusTime: 0,
      endSurplusTime: 0,
      endSurplusTime_delay: 0,

      secondTick: 0,
    }
  },
  created() {
    browser.init()
    // console.log('shareApp Live create');
    wxAuth.firstEnter(this)
    //输入的参数
    // console.log(this.$route.params)
    // console.log(this.$route.query)
    this.liveId = parseInt(this.$route.params.liveId)
    this.baseInfo.id = this.liveId



    // 创建定时器10s
    this.timer = setInterval(this.intervalCallBack, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  mounted() {
    // setTimeout(()=>{
      this.loadInfo()
    // }, 1000)
  },
  methods:{
    intervalCallBack(){
      if(!this.isEnableLive) return

      this.secondTick++

      // let surplusTime = utils.surplusTime(this.baseInfo.startTime)
      switch (this.status){
        //未开始
        case 1:
          this.checkIsStartLive()
          break;
        //直播中
        case 2:
          this.checkIsEndLive()
          break;
        //直播结束
        case 3:
          break;
        default:
          break;
      }
    },
    getItem(daily){
      let obj = {}
      obj.id = daily.id
      obj.title = daily.title
      obj.type = daily.type   //动态类型:0 文章 1 视频   (smallInteger)

      obj.goodNum = daily.goodNum //点赞数   (integer)
      obj.commentNum = daily.commentNum //评论数   (integer)
      obj.collectionNum = daily.collectionNum //收藏数   (integer)

      obj.imageCount = daily.imageCount ////图片数   (integer)
      obj.contentImage = JSON.parse(daily.contentImage) //图片内容包括视频预览图片 json数组   (text)
      obj.contentVideo = daily.contentVideo //视频内容  (string)

      obj.time = actUtil.remainingTime(daily.time)   //发布时间  (bigInteger)
      return obj
    },
    //重置状态
    resetStatus(){
      utils.resetRemainTime()
      // advance,      //提前（秒） (integer)
      // postpone,     //延后（秒） (integer)

      this.startSurplusTime = utils.remainingTime(this.baseInfo.startTime)
      this.endSurplusTime = utils.remainingTime(this.baseInfo.endTime)
      this.endSurplusTime_delay = utils.remainingTime(this.baseInfo.endTime+this.baseInfo.postpone)
      // this.startSurplusTime = utils.remainingTime(utils.getCurTickS()+5000)
      // this.endSurplusTime = utils.remainingTime(utils.getCurTickS()+5)

      //1 未开始
      let checkStatus = 1
      //2 已经开始
      if(this.startSurplusTime==0){
        checkStatus = 2
      }
      //3 已经结束
      if((this.endSurplusTime_delay==0)
          || (   (this.endSurplusTime==0)
                  &&((this.baseInfo.record!='')||(this.baseInfo.record1!=''))
              )
      ){
        checkStatus = 3
      }

      if(this.status!=checkStatus){
        this.status = checkStatus
      }
      // this.status = 0
      console.log("直播状态："+this.status)
    },
    loadInfo(){
      let obj = {
        'id': this.liveId
      }
      apiLive.getPlatformLive(obj).then(res=>{
        console.log(res)
        this.baseInfo = res.live
        this.baseInfo.liveTime = res.liveTime
        this.baseInfo.liveLecturer = res.liveLecturer
        // this.baseInfo.articles = res.articles
        this.baseInfo.articles = []

        if(typeof this.baseInfo.postpone == "undefined"){
          this.baseInfo.postpone = 0
        }
        if(typeof this.baseInfo.advance == "undefined"){
          this.baseInfo.advance = 0
        }
        if(typeof this.baseInfo.record1 == "undefined"){
          this.baseInfo.record1 = ''
        }
        if(typeof this.baseInfo.recordImage == "undefined"){
          this.baseInfo.recordImage = ''
        }



        this.baseInfo.articles.length = 0
        if(typeof res.articles != "undefined") {
          for (let i=0; i<res.articles.length; i++){
            let retObj = this.getItem(res.articles[i].daily)
            if(retObj!=null){
              this.baseInfo.articles.push(retObj)
            }
          }
        }

        this.resetStatus();
        this.isEnableLive = true

        openLaunchInit(this.baseInfo.shareTitle,
            this.baseInfo.shareNote,
            baseConfig.makeShareUrl('shareApp/shareLive/'+this.liveId),
            this.baseInfo.shareLogo)

        //查看预约状态
        this.getLiveStatus()
      }).catch(err=>{

      })
    },
    //检测是否提前开播，每秒调用一次
    checkIsStartLive(){
      if(!this.isEnableLive) return

      // this.startSurplusTime = utils.remainingTime(this.baseInfo.startTime)
      // this.endSurplusTime = utils.remainingTime(this.baseInfo.endTime)
      // this.endSurplusTime_delay = utils.remainingTime(this.baseInfo.endTime+this.baseInfo.postpone)

      if(this.startSurplusTime>0){
        // this.startSurplusTime--
        this.startSurplusTime = utils.remainingTime(this.baseInfo.startTime)
      }
      if(this.endSurplusTime>0){
        // this.endSurplusTime--
        this.endSurplusTime = utils.remainingTime(this.baseInfo.endTime)
      }
      if(this.endSurplusTime_delay>0){
        // this.endSurplusTime_delay--
        this.endSurplusTime_delay = utils.remainingTime(this.baseInfo.endTime+this.baseInfo.postpone)
      }

      console.log("开始剩余:"+this.startSurplusTime
          +" advance:"+ this.baseInfo.advance
          +" postpone:"+this.baseInfo.postpone
          +" 结束剩余:"+this.endSurplusTime
          +" 结束延迟剩余:"+ this.endSurplusTime_delay
          + "  record:"+this.baseInfo.record
          + "  record1:"+this.baseInfo.record1)
      // 是否已经开始直播
      if(this.startSurplusTime==0){
        this.status = 2
        return
      }
      console.log("提前准A")
      // 是否已经到了提前时间，未到退出
      if(this.startSurplusTime > this.baseInfo.advance) return

      console.log("提前准B:"+this.secondTick)
      //累计30秒，更新一次
      if(this.secondTick%10!=0) return

      console.log("重新请求数据")
      let obj = {
        'id': this.liveId
      }
      apiLive.getPlatformLive(obj).then(res=>{
        console.log(res)
        this.baseInfo.startTime = res.live.startTime
        this.baseInfo.endTime = res.live.endTime
        this.resetStatus();
      }).catch(err=>{
      })
    },
    //检测是否已经结束直播，每秒调用一次
    checkIsEndLive(){
      if(!this.isEnableLive) return

      if(this.endSurplusTime>0){
        // this.endSurplusTime--
        this.endSurplusTime = utils.remainingTime(this.baseInfo.endTime)
      }
      if(this.endSurplusTime_delay>0){
        // this.endSurplusTime_delay--
        this.endSurplusTime_delay = utils.remainingTime(this.baseInfo.endTime+this.baseInfo.postpone)
      }

      console.log("结束剩余:"+this.endSurplusTime
          + " 结束延迟剩余:"+ this.endSurplusTime_delay
          + " record:"+this.baseInfo.record
          + " record1:"+this.baseInfo.record1)

      // 是否已经直播结束时间
      if(this.endSurplusTime!=0) return

      console.log("准备结束A："+this.secondTick)

      // 直播结束时间已到，是否在延迟范围内，是，是否已经真正结束
      if((this.endSurplusTime_delay==0)
          || (   (this.endSurplusTime==0)
              &&((this.baseInfo.record!='')||(this.baseInfo.record1!=''))
          )
      ){
        console.log("准备结束ddddd："+this.secondTick)
        this.status = 3
        return
      }

      //累计30秒，更新一次
      if(this.secondTick%10!=0) return

      console.log("准备结束-重新获取数据："+this.secondTick)

      let obj = {
        'id': this.liveId
      }
      apiLive.getPlatformLive(obj).then(res=>{
        console.log(res)
        if(typeof res.live.record != "undefined"){
          this.baseInfo.record = res.live.record
        }
        if(typeof res.live.record1 != "undefined"){
          this.baseInfo.record1 = res.live.record1
        }
        this.resetStatus();
      }).catch(err=>{
      })
    },
    getLiveStatus(){
      if(!wxAuth.isAuth()){
        setTimeout(()=>{
          this.getLiveStatus()
        },1000)
        return
      }

      let obj = {
        'id': this.baseInfo.id,
        'type': 3
      }
      apiLive.getPlatformLiveStatus(obj).then(res=>{
        // console.log(res)
        this.isOrder = res.isOrder

        // console.log("是否已经预约： "+this.isOrder)
      }).catch(err=>{

      })
    }
  }
}
</script>

<style scoped>
.bgShareLive{
  /*background-color: #efefef;*/
  /*background-color: #ededed;*/

}
.hindBox{
  width: 100%;
  height: 615px;
  background-color: #666666;
}
.lvVideo{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
}
.infoBox{
  position: relative;
}
</style>